<button mat-stroked-button
        color="primary"
        [matTooltip]="'Show report information'"
        [matTooltipDisabled]="(drawerIsOpened$ | async) || (fullscreen$ | async)"
        [disabled]="(drawerIsOpened$ | async) || (fullscreen$ | async)"
        (click)="onOpenDrawer()">
  <mat-icon class="icon-1-4-rem">info</mat-icon>
</button>
